import SkeletonAnimatedContainer from './SkeletonAnimatedContainer';

export default SkeletonAnimatedContainer;
